export default {
  "content": "<path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M10.723 11.936a2.485 2.485 0 104.97 0 2.485 2.485 0 00-4.97 0zm8.873 5.83l-1.88-1.89a.44.44 0 00-.623 0 5.558 5.558 0 01-3.857 1.57 5.436 5.436 0 01-5.418-5.443 5.436 5.436 0 015.418-5.444c1.323 0 2.528.476 3.51 1.331.172.155.437.15.6-.018l1.88-1.885a.437.437 0 00-.021-.644C17.565 3.868 15.505 3 13.235 3c-4.94 0-8.96 4.038-8.96 9.003 0 4.962 4.02 8.997 8.96 8.997a8.999 8.999 0 006.361-2.611.443.443 0 000-.626\" fill=\"#7B61FF\"/>",
  "attrs": {
    "width": "24",
    "height": "24",
    "viewBox": "0 0 24 24",
    "fill": "none",
    "xmlns": "http://www.w3.org/2000/svg"
  }
};